import {Injectable} from '@angular/core';
import {
  CmsFlexComponentData,
  ParsedCmsFlexComponentData
} from '../checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {CmsComponentData} from '@spartacus/storefront';
import {JsonService} from '@dcp/configurator';
import {first, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {CmsComponent} from '@spartacus/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ComponentService {

  constructor(private jsonService: JsonService) {
  }

  fetchClassificationsProductData(cmsData: CmsComponentData<CmsFlexComponentData>): Observable<ParsedCmsFlexComponentData> {
    return this.fetchComponentData(cmsData, 'classificationsProductData');
  }

  fetchComponentData(cmsData: CmsComponentData<CmsComponent>, key: string): Observable<any> {
    return cmsData.data$.pipe(first(), map(data => {
      if (data[key]) {
        return this.jsonService.parseSafely(data[key]);
      }
      return null;
    }), untilDestroyed(this));
  }
}
